import React from "react";
import CountUp from "react-countup";
import "../css/OurImpact.css";

export default function OurImpact() {
  const manualSchoolCount = 25;
  const manualStudentCount = 10000;

  const impactStats = [
    {
      value: manualSchoolCount,
      suffix: "+",
      label: "Schools Partnered",
      description:
        "Partnering with schools to bring engaging technology learning into classrooms.",
      accent: "yellow",
      duration: 2,
      icon: (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M3 10.5 12 5l9 5.5-9 5.5-9-5.5Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />

          <path
            d="M6.5 13.2V17c0 1.2 2.45 2.7 5.5 2.7s5.5-1.5 5.5-2.7v-3.8"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />

          <path
            d="M21 10.5V16"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </svg>
      ),
    },

    {
      value: manualStudentCount,
      suffix: "+",
      label: "Students Trained",
      description:
        "Helping students explore Robotics, AI, Coding and STEM through hands-on learning.",
      accent: "blue",
      duration: 3,
      separator: ",",
      icon: (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <circle
            cx="9"
            cy="8"
            r="3"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
          />

          <path
            d="M3.5 19c.5-3.5 2.5-5.5 5.5-5.5s5 2 5.5 5.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />

          <path
            d="M16 7.5a2.5 2.5 0 1 1 0 5M16.5 14.5c2.2.3 3.6 1.8 4 4"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </svg>
      ),
    },
  ];

  return (
    <section className="ms-impact-section">
      {/* BACKGROUND */}
      <div className="ms-impact-grid" />

      <div className="ms-impact-glow ms-impact-glow-blue" />
      <div className="ms-impact-glow ms-impact-glow-yellow" />

      <div className="container ms-impact-container">
        {/* =========================================
            SECTION HEADING
        ========================================= */}
        <div className="ms-impact-heading">
          <div className="ms-impact-kicker">
            <span />

            OUR IMPACT
          </div>

          <h2>
            Growing together through
            <span> technology.</span>
          </h2>

          <p>
            Shaping future innovators through real-world,
            hands-on learning experiences.
          </p>
        </div>

        {/* =========================================
            CONTENT
        ========================================= */}
        <div className="ms-impact-content">
          {/* LEFT MESSAGE */}
          <div className="ms-impact-story">
            <div className="ms-impact-story-label">
              <span>✦</span>

              LEARNING THROUGH TECHNOLOGY
            </div>

            <h3>
              Every classroom reached is another opportunity
              to spark curiosity.
            </h3>

            <p>
              We are proud of the journey so far and continue
              working with schools and students to make
              technology learning practical, engaging and
              meaningful.
            </p>

            <div className="ms-impact-tags">
              <span className="yellow">
                Robotics
              </span>

              <span className="purple">
                AI
              </span>

              <span className="blue">
                Coding
              </span>

              <span className="teal">
                STEM
              </span>
            </div>
          </div>

          {/* RIGHT STATISTICS */}
          <div className="ms-impact-stats">
            {impactStats.map((stat) => (
              <article
                className={`ms-impact-card ${stat.accent}`}
                key={stat.label}
              >
                <div className="ms-impact-card-top">
                  <div className="ms-impact-icon">
                    {stat.icon}
                  </div>

                
                </div>

                <div className="ms-impact-number">
                  <CountUp
                    end={stat.value}
                    duration={stat.duration}
                    separator={stat.separator || ""}
                    enableScrollSpy
                    scrollSpyOnce
                  />

                  <span>{stat.suffix}</span>
                </div>

                <h3>{stat.label}</h3>

                <p>{stat.description}</p>

                <div className="ms-impact-card-line">
                  <span />
                </div>
              </article>
            ))}
          </div>
        </div>

        {/* =========================================
            BOTTOM MESSAGE
        ========================================= */}
        <div className="ms-impact-bottom">
          <span className="ms-impact-bottom-line" />

          <p>
            Building confident learners, one experience at a
            time.
          </p>

          <span className="ms-impact-bottom-line" />
        </div>
      </div>
    </section>
  );
}
